import gql from 'graphql-tag';

export const ERROR_DIAGNOSIS_QUERY = gql`
  query errorDiagnosis(
    $search: String!
    $size: Int
    $page: Int
    $sortOrder: String!
    $sortColumn: String!
    $startDate: String!
    $endDate: String!
  ) {
    errorDiagnosis(
      search: $search
      size: $size
      page: $page
      sortOrder: $sortOrder
      sortColumn: $sortColumn
      startDate: $startDate
      endDate: $endDate
    )
      @rest(
        method: "GET"
        type: "errorDiagnosis"
        path: "api/v1/broker/events?search={args.search}&size={args.size}&page={args.page}&sort={args.sortColumn}&sortDirection={args.sortOrder}&startDate={args.startDate}&endDate={args.endDate}"
      ) {
      content
      pageable
      totalElements
    }
  }
`;

export const ERROR_DIAGNOSIS_QUERY_FREIGHT_TRACKING = gql`
  query errorDiagnosisFreightTracking(
    $participantCode: String!
    $startDate: String!
    $endDate: String!
    $search: String!
    $size: Int
    $page: Int
  ) {
    errorDiagnosisFreightTracking(
      participantCode: $participantCode
      startDate: $startDate
      endDate: $endDate
      search: $search
      size: $size
      page: $page
    )
      @rest(
        method: "GET"
        type: "errorDiagnosisFreightTracking"
        path: "api/v1/broker/audit/shipment/{args.participantCode}?endDate={args.endDate}&size={args.size}&page={args.page}&sortDirection=DESC&sort=lmd&startDate={args.startDate}&search={args.search}"
      ) {
      content
      pageable
      totalElements
    }
  }
`;
export const ERROR_DIAGNOSIS_QUERY_FT_EVENTS_AUDITS = gql`
  query errorDiagnosisFTEventsAudits($participantCode: String!, $search: String!, $size: Int, $page: Int) {
    errorDiagnosisFTEventsAudits(
      participantCode: $participantCode
      startDate: $startDate
      endDate: $endDate
      search: $search
      size: $size
      page: $page
    )
      @rest(
        method: "GET"
        type: "errorDiagnosisFTEventsAudits"
        path: "api/v1/broker/audit/events/{args.participantCode}?sortDirection=DESC&size={args.size}&page={args.page}&search={args.search}"
      ) {
      content
      pageable
      totalElements
    }
  }
`;

export const ERROR_DIAGNOSIS_QUERY_FT_EVENTS = gql`
  query errorDiagnosisFTEvents(
    $participantCode: String!
    $startDate: String!
    $endDate: String!
    $search: String!
    $size: Int
    $page: Int
  ) {
    errorDiagnosisFTEvents(
      participantCode: $participantCode
      startDate: $startDate
      endDate: $endDate
      search: $search
      size: $size
      page: $page
    )
      @rest(
        method: "GET"
        type: "errorDiagnosisFTEvents"
        path: "api/v1/broker/audit/events/{args.participantCode}?sortDirection=DESC&size={args.size}&page={args.page}&search={args.search}&startDate={args.startDate}&endDate={args.endDate}"
      ) {
      content
      pageable
      totalElements
    }
  }
`;

export const PARTICIPANT_ERROR_COUNTS_QUERY = gql`
  query participantErrorCounts($startDate: String!, $endDate: String!, $participantCode: String) {
    participantErrorCounts(startDate: $startDate, endDate: $endDate, participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "participantErrorCounts"
        path: "api/v1/luminetAuditEvent/errorCounts?startDate={args.startDate}&endDate={args.endDate}&participantCode={args.participantCode}"
      ) {
      count
      service
    }
  }
`;

export const ERROR_COUNTS_QUERY = gql`
  query errorCounts($startDate: String!, $endDate: String!) {
    errorCounts(startDate: $startDate, endDate: $endDate)
      @rest(
        method: "GET"
        type: "errorCounts"
        path: "api/v1/luminetAuditEvent/errorCounts?startDate={args.startDate}&endDate={args.endDate}"
      ) {
      count
      service
    }
  }
`;

export const EVENT_REQUEST_RESPONSE_QUERY = gql`
  query requestResponse($eventId: String!) {
    requestResponse(eventId: $eventId)
      @rest(method: "GET", type: "requestResponse", path: "api/v1/broker/events/requestResponse?id={args.eventId}") {
      requestBody
      responseBody
      postTransformRequest
      preTransformResponse
      additionalInfo
    }
  }
`;

export const ARCHIVE_REQUEST_RESPONSE_QUERY = gql`
  query requestResponse($eventId: String!) {
    requestResponse(eventId: $eventId)
      @rest(method: "GET", type: "requestResponse", path: "api/v1/selfcertificate/audit/getEventData/{args.eventId}") {
      requestBody
      responseBody
      postTransformRequest
      preTransformResponse
      additionalInfo
      apiDateTime
      errorMessage
      eventType
      initialResponseHttpStatus
      messageId
      operationHttpStatus
      receiverCode
      requestType
      responseStatus
      retryStatus
      statusCode
      timeTaken
      auditInfo
    }
  }
`;

export const PARTICIPANT_SUMMARY = gql`
  query {
    participantInfo @rest(method: "GET", type: "participantInfo", path: "api/v1/broker/participant/summary?size=1000") {
      content
      pageable
    }
  }
`;

export const ADD_PARTICIPANT = gql`
  mutation addParticipants(
    $participantCode: String!
    $participantType: String
    $companyName: String
    $primaryEmail: String
    $additionalCreds: any
    $method: String
  ) {
    addParticipants(
      input: {
        participantCode: $participantCode
        participantType: $participantType
        companyName: $companyName
        primaryEmail: $primaryEmail
        additionalCreds: $additionalCreds
      }
    ) @rest(method: $method, type: "addParticipants", path: "api/v1/broker/participant") {
      participantCode
      clientCredentials
    }
  }
`;

export const WORKFLOW_SUBSCRIBERS_SUMMARY_QUERY = gql`
  query workflowSubscriberSummary($participantType: String!, $participantCode: String!) {
    workflowSubscriberSummary(participantType: $participantType, participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "workflowSubscriberSummary"
        path: "api/v1/broker/workflow/summary/{args.participantCode}/{args.participantType}"
      ) {
      workflowCode
      workflowName
      partnerCount
      subscriptionLimit
      subscriptionThreshold
      requireTransform
      providerCustomerCodePath
      tid
    }
  }
`;
export const CUSTOMER_PROVIDER_RELATION_QUERY = gql`
  query customerProviderRelation($workflowCode: String!, $participantCode: String!) {
    customerProviderRelation(workflowCode: $workflowCode, participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "customerProviderRelation"
        path: "api/v1/broker/workflow/{args.workflowCode}/participant/{args.participantCode}"
      ) {
      workflowCode
      providerCode
      customerCode
      providerCustomerCode
      status
      additionalCreds
      operationUrls
      aggregatorCode
      connectionConfig
      connectionNote
      createdDate
      lastUpdated
    }
  }
`;

export const AGGREGATOR_PROVIDER_QUERY = gql`
  query aggregatorProviderRelation($workflowCode: String!, $aggregatorCode: String!) {
    aggregatorProviderRelation(workflowCode: $workflowCode, aggregatorCode: $aggregatorCode)
      @rest(
        method: "GET"
        type: "aggregatorProviderRelation"
        path: "api/v1/broker/subscribe/participant?search=aggregatorCode={args.aggregatorCode};workflowCode={args.workflowCode}"
      ) {
      content
    }
  }
`;

export const CUSTOMER_AGGREGATOR_QUERY = gql`
  query customerAgggregatorRelation($workflowCode: String!, $aggregatorCode: String!) {
    customerAgggregatorRelation(workflowCode: $workflowCode, aggregatorCode: $aggregatorCode)
      @rest(
        method: "GET"
        type: "customerAgggregatorRelation"
        path: "api/v1/broker/subscribe/operations?search=aggregatorCode={args.aggregatorCode};workflowCode={args.workflowCode}"
      ) {
      content
    }
  }
`;

export const DISABLE_CUSTOMER_PROVIDER_RELATIONSHIP = gql`
  mutation disableRelation(
    $providerCode: String
    $customerCode: String
    $workflowCode: String
    $aggregatorCode: String
  ) {
    disableRelation(
      input: [
        {
          providerCode: $providerCode
          customerCode: $customerCode
          workflowCode: $workflowCode
          aggregatorCode: $aggregatorCode
        }
      ]
    ) @rest(method: "POST", type: "disableRelation", path: "api/v1/broker/workflow/enable/disableRelation") {
      status
    }
  }
`;

export const ADD_CUSTOMER_PROVIDER_RELATION = gql`
  mutation addCustomerProviderRelation(
    $workflowCode: String!
    $providerCode: String
    $customerCode: String
    $providerCustomerCode: String
    $additionalCreds: any
    $operationUrls: any
    $method: String
    $aggregatorCode: String
    $status: String
    $connectionConfig: any
    $connectionNote: any
  ) {
    addCustomerProviderRelation(
      input: {
        workflowCode: $workflowCode
        providerCode: $providerCode
        customerCode: $customerCode
        providerCustomerCode: $providerCustomerCode
        additionalCreds: $additionalCreds
        operationUrls: $operationUrls
        aggregatorCode: $aggregatorCode
        status: $status
        connectionConfig: $connectionConfig
        connectionNote: $connectionNote
      }
    ) @rest(method: $method, type: "addCustomerProviderRelation", path: "api/v1/broker/workflow/enable") {
      workflowCode
    }
  }
`;

export const WORKFLOW_LIST = gql`
  {
    workflow @client {
      content
    }
  }
`;

export const EDIT_SERVICE = gql`
  mutation editService($editOperations: any) {
    editService(input: $editOperations)
      @rest(method: "PUT", type: "editService", path: "/api/v1/broker/workflow/operations/updateAll") {
      content
    }
  }
`;

export const ENABLE_SERVICE = gql`
  mutation enableService(
    $workflowCode: String!
    $participantCode: String
    $subscriptionLimit: String
    $connectionNote: String
    $subscriptionThreshold: String
    $interestedParties: String
    $enableOperations: any
    $providerCustomerCodePath: String
    $requireTransform: any
    $authContext: String
    $method: String
    $aggregatorCode: String
    $tid: String
  ) {
    enableService(
      input: {
        workflowCode: $workflowCode
        participantCode: $participantCode
        subscriptionLimit: $subscriptionLimit
        connectionNote: $connectionNote
        subscriptionThreshold: $subscriptionThreshold
        interestedParties: $interestedParties
        enableOperations: $enableOperations
        providerCustomerCodePath: $providerCustomerCodePath
        requireTransform: $requireTransform
        authContext: $authContext
        aggregatorCode: $aggregatorCode
        tid: $tid
      }
    ) @rest(method: $method, type: "addParticipants", path: "api/v1/broker/subscribe/participant") {
      participantCode
    }
  }
`;

export const SUBSCRIBED_SERVICES = gql`
  query subscribedService($workflowCode: String!) {
    subscribedService(workflowCode: $workflowCode)
      @rest(
        method: "GET"
        type: "subscribedService"
        path: "api/v1/broker/subscribe/participant?search=workflowCode={args.workflowCode}"
      ) {
      content
    }
  }
`;

export const FETCH_SERVICE_AUDIT_HISTORY_QUERY = gql`
  query fetchAuditService($participantCode: String!, $workflowCode: String!) {
    fetchAuditService(participantCode: $participantCode, workflowCode: $workflowCode)
      @rest(
        method: "GET"
        type: "fetchAuditService"
        path: "api/v1/broker/workflow/subscribers/audit/allrevisions?workflowCode={args.workflowCode}&participantCode={args.participantCode}"
      ) {
      content
      pageable
      totalElements
    }
  }
`;

export const PARTICIPANT_QUERY = gql`
  query participant($participantCode: String!) {
    participant(participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "participant"
        path: "api/v1/broker/participant?search=participantCode={args.participantCode}"
      ) {
      content
    }
  }
`;

export const SERVICES_SUMMARY = gql`
  query {
    workflowInfo @rest(method: "GET", type: "workflowInfo", path: "api/v1/broker/workflow/summary") {
      workflowName
      workflowCode
      customers
      providers
    }
  }
`;

export const SERVICE_QUERY = gql`
  query($workflowCode: String!) {
    serviceInfo(workflowCode: $workflowCode)
      @rest(
        method: "GET"
        type: "serviceInfo"
        path: "api/v1/broker/participant/subscribers/workflow/{args.workflowCode}/participantType/CUSTOMER"
      ) {
      participantCode
      participantType
      companyName
    }
  }
`;

export const SERVICE_QUERY_PROVIDER = gql`
  query($workflowCode: String!) {
    providerInfo(workflowCode: $workflowCode)
      @rest(
        method: "GET"
        type: "providerInfo"
        path: "api/v1/broker/participant/subscribers/workflow/{args.workflowCode}/participantType/PROVIDER"
      ) {
      participantCode
      participantType
      companyName
    }
  }
`;

export const SERVICE_QUERY_AGGREGATOR = gql`
  query($workflowCode: String!, $participantType: String!) {
    aggregatorInfo(workflowCode: $workflowCode, participantType: $participantType)
      @rest(
        method: "GET"
        type: "aggregatorInfo"
        path: "api/v1/broker/participant/subscribers/workflow/{args.workflowCode}/participantType/{args.participantType}"
      ) {
      participantCode
      participantType
      companyName
    }
  }
`;

export const USER_DETAILS = gql`
  query {
    userProfile @rest(method: "GET", type: "userProfile", path: "api/v1/broker/user/me") {
      tid
      userName
      roles
      participantRoleInfos
      userInfo
    }
  }
`;

export const USER_PROFILE_SAVE = gql`
  mutation profileSave($userName: any, $preferences: any) {
    profileSave(input: [{ userName: $userName, preferences: $preferences }])
      @rest(method: "PUT", type: "profileSave", path: "api/v1/broker/user") {
      data
    }
  }
`;

export const PARTICIPANT_SUBSCRIBED_QUERY = gql`
  query participantSubscribed(
    $workflowCode: String!
    $participantType: String!
    $participantCode: String!
    $filterExistingParticipants: any!
  ) {
    participantSubscribed(
      workflowCode: $workflowCode
      participantType: $participantType
      participantCode: $participantCode
      filterExistingParticipants: $filterExistingParticipants
    )
      @rest(
        method: "GET"
        type: "participantSubscribed"
        path: "api/v1/broker/participant/subscribers/workflow/{args.workflowCode}/participantType/{args.participantType}?participantCode={args.participantCode}&filterExistingParticipants={args.filterExistingParticipants}"
      ) {
      participantCode
      participantType
      companyName
      primaryEmail
      status
      additionalCreds
    }
  }
`;

export const AGGREGATOR_SUBSCRIBED_QUERY = gql`
  query aggregatorSubscribed(
    $workflowCode: String!
    $participantType: String!
    $participantCode: String!
    $filterExistingParticipants: any!
  ) {
    aggregatorSubscribed(
      workflowCode: $workflowCode
      participantType: $participantType
      participantCode: $participantCode
      filterExistingParticipants: $filterExistingParticipants
    )
      @rest(
        method: "GET"
        type: "aggregatorSubscribed"
        path: "api/v1/broker/participant/subscribers/workflow/{args.workflowCode}/participantType/AGGREGATOR?participantCode={args.participantCode}&filterExistingParticipants={args.filterExistingParticipants}"
      ) {
      participantCode
      participantType
      companyName
      primaryEmail
      status
      additionalCreds
    }
  }
`;

export const ADD_AUTHENTICATION_QUERY = gql`
  mutation addAuthentication(
    $participantCode: String!
    $initiatorCode: String
    $workflowCode: String
    $authMode: String
    $defaultAuth: String
    $authContext: String
    $identifier: String
    $secret: String!
    $authUrl: String
    $additionalCreds: any
    $method: String
  ) {
    addAuthentication(
      input: {
        participantCode: $participantCode
        initiatorCode: $initiatorCode
        workflowCode: $workflowCode
        authMode: $authMode
        defaultAuth: $defaultAuth
        authContext: $authContext
        identifier: $identifier
        secret: $secret
        authUrl: $authUrl
        additionalCreds: $additionalCreds
        method: $method
      }
    ) @rest(method: $method, type: "addAuthentication", path: "api/v1/broker/authentication") {
      workflowCode
    }
  }
`;

export const FETCH_AUTHENTICATION_QUERY = gql`
  query fetchAuthentication($participantCode: String!) {
    fetchAuthentication(participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "fetchAuthentication"
        path: "api/v1/broker/authentication?search=participantCode={args.participantCode}"
      ) {
      content
      pageable
    }
  }
`;

export const FETCH_AUTHENTICATION_AUDIT_HISTORY_QUERY = gql`
  query fetchAuditAuthentication($participantCode: String!) {
    fetchAuditAuthentication(participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "fetchAuditAuthentication"
        path: "api/v1/broker/authentication/audit/allrevisions?authContext=Default&participantCode={args.participantCode}&size=10&sort=__revisionNumber__,desc"
      ) {
      content
      pageable
      totalElements
    }
  }
`;

export const ALL_AUTHENTICATION_QUERY = gql`
  query {
    allAuthentication @rest(method: "GET", type: "allAuthentication", path: "api/v1/broker/authentication") {
      content
    }
  }
`;

export const VALIDATE_AUTHENTICATION_QUERY = gql`
  query validateAuthentication($participantCode: String!, $authContext: String!) {
    validateAuthentication(participantCode: $participantCode, authContext: $authContext)
      @rest(
        method: "GET"
        type: "validateAuthentication"
        path: "api/v1/broker/authentication/validateAuthContext/{args.participantCode}?authContext={args.authContext}"
      ) {
      content
    }
  }
`;

export const DELETE_AUTHENTICATION_QUERY = gql`
  mutation deleteAuthentication($participantCode: String!, $authContext: String!) {
    deleteAuthentication(input: { participantCode: $participantCode, authContext: $authContext })
      @rest(method: "POST", type: "deleteAuthentication", path: "api/v1/broker/authentication/delete") {
      content
    }
  }
`;

export const ALL_PRATICIPANT_AUTHENTICATION_QUERY = gql`
  query allParticipantAuthentication($participantType: String!) {
    allParticipantAuthentication(participantType: $participantType)
      @rest(
        method: "GET"
        type: "allParticipantAuthentication"
        path: "api/v1/broker/authentication/participant/{args.participantType}?size=1000"
      ) {
      content
    }
  }
`;

export const FETCH_AUTHENTICATION_CONTEXT_QUERY = gql`
  query fetchAuthentication($participantCode: String!) {
    fetchAuthentication(participantCode: $participantCode, authContext: $authContext)
      @rest(
        method: "GET"
        type: "fetchAuthentication"
        path: "api/v1/broker/authentication?search=participantCode={args.participantCode}&authContext={args.authContext}"
      ) {
      content
      pageable
    }
  }
`;

export const SUBSCRIBED_PARTICIPANT_WORKFLOW_QUERY = gql`
  query subscribedParticipantWorkflow($participantCode: String!) {
    subscribedParticipantWorkflow(participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "subscribedParticipantWorkflow"
        path: "api/v1/broker/subscribe/participant?search=participantCode={args.participantCode}"
      ) {
      content
      pageable
    }
  }
`;

export const DPD_SUMMARY_QUERY = gql`
  query DPDSummary($startDate: any!, $endDate: any!) {
    DPDSummary(startDate: $startDate, endDate: $endDate)
      @rest(
        method: "GET"
        type: "DPDSummary"
        path: "api/v1/luminetAuditEvent/dpdSummary?startDate={args.startDate}&endDate={args.endDate}&queryType=ALL"
      ) {
      date
      count
      status
    }
  }
`;

export const TRANSACTIONS_SUMMARY_QUERY = gql`
  query TransactionsSummary($query: any!) {
    TransactionsSummary(query: $query)
      @rest(method: "GET", type: "TransactionsSummary", path: "api/v1/luminetAuditEvent/httpStatusCount?{args.query}") {
      date
      count
      httpResponseStatus
    }
  }
`;

export const TRANSFORM_SPEC_LIST = gql`
  query TransformSpecInfo($participantCode: any!, $workflowCode: any!) {
    TransformSpecInfo(participantCode: $participantCode, workflowCode: $workflowCode)
      @rest(
        method: "GET"
        type: "TransformSpecInfo"
        path: "api/v1/selfcertificate/transform/getTransformSpec?participantCode={args.participantCode}&workflowCode={args.workflowCode}"
      ) {
      operationCode
      type
      httpStatus
      spec
      draftSpec
      comments
      transformType
    }
  }
`;

export const TRANSFORM_SPEC_HISTORY = gql`
  query TransformSpecHistory(
    $participantCode: any!
    $workflowCode: any!
    $operationCode: any!
    $type: any!
    $httpStatusCode: any!
  ) {
    TransformSpecHistory(
      participantCode: $participantCode
      workflowCode: $workflowCode
      operationCode: $operationCode
      type: $type
      httpStatusCode: $httpStatusCode
    )
      @rest(
        method: "GET"
        type: "TransformSpecHistory"
        path: "api/v1/selfcertificate/transform/audit/allrevisions?participantCode={args.participantCode}&workflowCode={args.workflowCode}&operationCode={args.operationCode}&type={args.type}&httpStatusCode={args.httpStatusCode}&size=100&sort=__revisionNumber__,desc"
      ) {
      content
      pageable
    }
  }
`;

export const UPDATE_TRANSFORM_SPEC = gql`
  mutation updateTransformSpec(
    $workflowCode: String!
    $operationCode: String
    $participantCode: String
    $type: String
    $httpStatus: String
    $spec: String
    $draftSpec: String
    $comments: String
    $method: String
  ) {
    updateTransformSpec(
      input: {
        workflowCode: $workflowCode
        operationCode: $operationCode
        participantCode: $participantCode
        type: $type
        httpStatus: $httpStatus
        spec: $spec
        draftSpec: $draftSpec
        comments: $comments
      }
    ) @rest(method: $method, type: "updateTransformSpec", path: "api/v1/selfcertificate/transform") {
      httpStatus
    }
  }
`;

export const TRANSFORM_QUERY = gql`
  mutation joltTransform($input: String, $spec: String, $formSerializer: any) {
    joltTransform(input: { input: $input, spec: $spec })
      @rest(
        method: "POST"
        type: "joltTransform"
        path: "api/v1/selfcertificate/transform/validateTransform"
        bodySerializer: $formSerializer
      ) {
      data
    }
  }
`;

export const GET_DEFAULT_OPERATION_DATA = gql`
  query GetDefaultOperationData($workflowCode: any!, $operationCode: any!) {
    GetDefaultOperationData(workflowCode: $workflowCode, operationCode: $operationCode)
      @rest(
        method: "GET"
        type: "GetDefaultOperationData"
        path: "api/v1/selfcertificate/transform/getDefaultData?workflowCode={args.workflowCode}&operationCode={args.operationCode}"
      ) {
      data
    }
  }
`;

export const REPLAY_QUERY = gql`
  mutation replayInfo($eventId: ID) {
    replayInfo(input: { eventId: $eventId })
      @rest(method: "POST", type: "replayInfo", path: "api/v1/broker/events/replay?ids={args.input.eventId}") {
      data
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($ids: any) {
    deleteNotification(id: $ids, input: [])
      @rest(
        method: "PUT"
        type: "deleteNotification"
        path: "api/v1/selfcertificate/notificationRule/delete?ids={args.id}"
      ) {
      status
    }
  }
`;

export const RUN_NOTIFICATION_QUERY = gql`
  mutation runNotification($notificationID: any) {
    runNotification(input: { notificationID: $notificationID })
      @rest(
        method: "GET"
        type: "runNotification"
        path: "api/v1/selfcertificate/notificationRule/triggerJob/{args.input.notificationID}"
      ) {
      status
    }
  }
`;

export const FETCH_NOTIFICATION_QUERY = gql`
  query GetNotificationData($participant: any) {
    GetNotificationData(participant: $participant)
      @rest(
        method: "GET"
        type: "GetNotificationData"
        path: "api/v1/selfcertificate/notificationRule?participant={args.participant}"
      ) {
      notificationName
      timeSpan
      thresholdValue
      notificationMessage
      thresholdType
      thresholdLimit
      thresholdMet
      email
      cronExpression
      id
      searchPeriod
      filterRule
      webhookUrl
    }
  }
`;

export const FETCH_ALL_NOTIFICATION_QUERY = gql`
  query FetchAllNotifications($jobStatus: String, $participant: any, $page: any) {
    FetchAllNotifications(jobStatus: $jobStatus, participant: $participant, page: $page)
      @rest(
        method: "GET"
        type: "FetchAllNotifications"
        path: "api/v1/selfcertificate/notificationRule/result?jobStatus={args.jobStatus}&participant={args.participant}&sort=jobExecutedTime,DESC&page={args.page}"
      ) {
      content
      totalElements
    }
  }
`;

export const NOTIFICATION_RULE_QUERY = gql`
  mutation notificationRule(
    $notificationName: String!
    $timeSpan: any
    $thresholdValue: any
    $thresholdLimit: any
    $thresholdType: String
    $filterRule: String
    $notificationMessage: String
    $searchPeriod: any
    $thresholdMet: any
    $email: String
    $cronExpression: String
    $id: any
    $participant: any
    $method: String
    $webhookUrl: String
  ) {
    notificationRule(
      input: {
        notificationName: $notificationName
        timeSpan: $timeSpan
        thresholdValue: $thresholdValue
        thresholdLimit: $thresholdLimit
        thresholdType: $thresholdType
        filterRule: $filterRule
        notificationMessage: $notificationMessage
        searchPeriod: $searchPeriod
        thresholdMet: $thresholdMet
        email: $email
        cronExpression: $cronExpression
        id: $id
        participant: $participant
        webhookUrl: $webhookUrl
        method: $method
      }
    ) @rest(method: $method, type: "notificationRule", path: "api/v1/selfcertificate/notificationRule") {
      content
    }
  }
`;

export const AUDIT_HISTORY = gql`
  query auditHistory($search: String!) {
    auditHistory(search: $search)
      @rest(
        method: "GET"
        type: "auditHistory"
        path: "api/v1/selfcertificate/audit/getAuditHistory?search={args.search}"
      ) {
      hasMoreResults
      isPageComplete
      length
      pageSize
      remainingPageResults
      results
      continuationToken
    }
  }
`;

export const FETCH_USERS = gql`
  query {
    userProfile @rest(method: "GET", type: "userProfile", path: "api/v1/broker/user/tenantUsers") {
      count
      data
      dataType
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($userName: String) {
    deleteUser(input: { userName: $userName })
      @rest(method: "POST", type: "deleteUser", path: "/api/v1/broker/user/deleteUser/{args.input.userName}") {
      status
    }
  }
`;

export const GET_USER = gql`
  mutation getUser($userName: String!) {
    getUser(userName: $userName)
      @rest(method: "GET", type: "getUser", path: "/api/v1/broker/user?userName={args.userName}") {
      count
      data
      dataType
    }
  }
`;

export const ADD_USER = gql`
  mutation addUser(
    $userName: String!
    $userType: any
    $firstName: String!
    $lastName: String!
    $status: String!
    $method: String!
  ) {
    addUser(
      userType: $userType
      participantCode: $participantCode
      input: [{ userName: $userName, userType: $userType, firstName: $firstName, lastName: $lastName, status: $status }]
    ) @rest(method: $method, type: "addUser", path: "api/v1/broker/user/addUser?tenantRole={args.userType}") {
      content
    }
  }
`;

export const FETCH_USER_ROLE = gql`
  mutation fetchUserRole($userName: String, $participantCode: String) {
    fetchUserRole(input: { userName: $userName, participantCode: $participantCode })
      @rest(
        method: "GET"
        type: "fetchUserRole"
        path: "/api/v1/broker/user/tenantUsers?userId={args.input.userName}&participantCode={args.input.participantCode}"
      ) {
      data
      fetchUserRole
    }
  }
`;

export const FETCH_TENANT_USERS = gql`
  query fetchTenantUsers($userId: String, $participantCode: String) {
    fetchTenantUsers(userId: $userId, participantCode: $participantCode)
      @rest(
        method: "GET"
        type: "fetchTenantUsers"
        path: "/api/v1/broker/user/tenantUsers?participantCode={args.participantCode}"
      ) {
      count
      data
      dataType
    }
  }
`;

export const DELETE_TENANT_USER = gql`
  mutation deleteTenantUser($userName: String, $participantCode: String) {
    deleteTenantUser(input: { userName: $userName, participantCode: $participantCode })
      @rest(
        method: "POST"
        type: "deleteTenantUser"
        path: "/api/v1/broker/user/deleteTenant/{args.input.userName}?participantCode={args.input.participantCode}"
      ) {
      status
    }
  }
`;

export const ADD_TENANT_USER = gql`
  mutation addUser(
    $userName: String!
    $userType: any
    $firstName: String!
    $lastName: String!
    $status: String!
    $method: String!
    $participantCode: String
  ) {
    addUser(
      userType: $userType
      participantCode: $participantCode
      input: [{ userName: $userName, userType: $userType, firstName: $firstName, lastName: $lastName, status: $status }]
    )
      @rest(
        method: $method
        type: "addUser"
        path: "api/v1/broker/user/addUser?tenantRole={args.userType}&participantCode={args.participantCode}"
      ) {
      content
    }
  }
`;

export const GET_OPERATION_DATA = gql`
  query getSimulatedData($search: String) {
    simulatedData(search: $search)
      @rest(method: "GET", type: "simulatedData", path: "api/v1/selfcertificate/testdata/search?{args.search}") {
      content
      totalElements
      size
    }
  }
`;

export const GET_SIMULATION_DATA = gql`
  query getSimulatedData($search: String) {
    simulatedData(search: $search)
      @rest(method: "GET", type: "simulatedData", path: "api/v1/selfcertificate/testdata?{args.search}") {
      configSpec
      testDataName
      description
      input
      operation
      serviceNm
    }
  }
`;

export const POST_SIMULATION_DATA = gql`
  mutation postSimulatedData($workflowCode: String, $operationCode: String, $payload: Any, $search: any) {
    postsimulatedData(workflowCode: $workflowCode, operationCode: $operationCode, input: $payload, search: $search)
      @rest(
        method: "POST"
        type: "addSimulatedData"
        path: "api/v1/selfcertificate/events/simulate/{args.workflowCode}/{args.operationCode}{args.search}"
      ) {
      request
      response
    }
  }
`;

export const GET_SIMULATION_TEST_DATA = gql`
  query getSimulationTestData($workflowCode: String, $operationCode: String) {
    getSimulationTestData(workflowCode: $workflowCode, operationCode: $operationCode)
      @rest(
        method: "GET"
        type: "getSimulationTestData"
        path: "api/v1/selfcertificate/transform/getDefaultData?workflowCode={args.workflowCode}&operationCode={args.operationCode}"
      ) {
      data
    }
  }
`;
export const GET_TEST_EXECUTION_DATA = gql`
  query getExecutionData($participantCode: String, $testScenarioNm: String, $serviceNm: String) {
    getExecutionData(participantCode: $participantCode, testScenarioNm: $testScenarioNm, serviceNm: $serviceNm)
      @rest(
        method: "GET"
        type: "executionData"
        path: "api/v1/selfcertificate/testExecution?participantCode={args.participantCode}&testScenarioNm={args.testScenarioNm}&serviceNm={args.serviceNm}"
      ) {
      participantCode
      serviceNm
      status
      testScenarioExecutionSeq
      testScenarioName
      transactionId1
    }
  }
`;

export const POST_SIMULATION_TEST_DATA = gql`
  mutation postSimulationTestData(
    $payload: String!
    $description: any
    $serviceNm: String!
    $operation: String!
    $input: String!
    $configSpec: String!
    $method: String!
    $testScenarioSeq: any
    $testDataName: String!
  ) {
    postSimulationTestData(
      input: {
        testDataName: $testDataName
        description: $description
        serviceNm: $serviceNm
        operation: $operation
        input: $input
        configSpec: $configSpec
        testScenarioSeq: $testScenarioSeq
      }
    ) @rest(method: $method, type: "postSimulationTestData", path: "api/v1/selfcertificate/testdata") {
      content
    }
  }
`;
export const DELETE_OPERATION = gql`
  mutation deleteOperation($testDataName: String!, $serviceNm: String!, $operation: String!) {
    deleteOperation(input: [{ testDataName: $testDataName, serviceNm: $serviceNm, operation: $operation }])
      @rest(method: "PUT", type: "deleteOperation", path: "api/v1/selfcertificate/testdata/delete") {
      content
    }
  }
`;

export const WORKFLOW_QUERY = gql`
  query {
    workflow @rest(method: "GET", type: "workflow", path: "api/v1/broker/workflow") {
      content
      pageable
    }
  }
`;

export const RESET_CREDENTIALS = gql`
  mutation postResetCredsData($participantCode: String) {
    postResetCredsData(input: { participantCode: $participantCode })
      @rest(
        method: "POST"
        type: "resetCredsData"
        path: "api/v1/broker/participant/resetClientCredentials/{args.input.participantCode}"
      ) {
      clientCredentials
    }
  }
`;

export const TEST_SCENARIO = gql`
  mutation testScenario($payload: any, $method: String!) {
    testScenario(input: $payload)
      @rest(method: $method, type: "testScenario", path: "api/v1/selfcertificate/testScenario") {
      participantType
      serviceNm
      testScenarioName
      testStepSequence
      description
    }
  }
`;

export const DELETE_SCENARIO = gql`
  mutation deleteScenario($payload: any) {
    deleteScenario(input: $payload)
      @rest(method: "PUT", type: "deleteScenario", path: "api/v1/selfcertificate/testScenario/delete") {
      participantType
      serviceNm
      testScenarioName
      testStepSequence
      description
    }
  }
`;
export const EXECUTE_SCENARIO = gql`
  mutation executeScenario(
    $participantCode: any
    $testScenarioNm: String
    $operation: String
    $testSequence: String
    $serviceNm: String
    $input: any
  ) {
    executeScenario(
      input: $input
      participantCode: $participantCode
      testScenarioNm: $testScenarioNm
      operation: $operation
      testSequence: $testSequence
      serviceNm: $serviceNm
    )
      @rest(
        method: "POST"
        type: "executeScenario"
        path: "api/v1/selfcertificate/send/{args.serviceNm}/{args.operation}?participantCode={args.participantCode}&testScenarioNm={args.testScenarioNm}&testSequence={args.testSequence}"
      ) {
      participantCode
      serviceNm
      status
      testScenarioExecutionSeq
      testScenarioName
      transactionId1
    }
  }
`;

export const UPDATE_SEQUENCE = gql`
  mutation updateSequence(
    $testScenarioNm: String
    $participantCode: String
    $testSequence: String
    $status: String
    $serviceNm: String
  ) {
    updateSequence(
      testScenarioNm: $testScenarioNm
      participantCode: $participantCode
      testSequence: $testSequence
      status: $status
      serviceNm: $serviceNm
      input: {}
    )
      @rest(
        method: "PUT"
        type: "updateSequence"
        path: "api/v1/selfcertificate/testScenarioExecutionSeq/updateStatus?participantCode={args.participantCode}&testScenarioNm={args.testScenarioNm}&testSequence={args.testSequence}&status={args.status}&serviceNm={args.serviceNm}"
      ) {
      content
    }
  }
`;
export const UPDATE_SCENARIO = gql`
  mutation updateScenario($testScenarioNm: String, $participantCode: String, $status: String, $serviceNm: String) {
    updateScenario(
      testScenarioNm: $testScenarioNm
      participantCode: $participantCode
      status: $status
      serviceNm: $serviceNm
      input: {}
    )
      @rest(
        method: "PUT"
        type: "updateScenario"
        path: "api/v1/selfcertificate/testScenarioExecution/updateStatus?participantCode={args.participantCode}&testScenarioNm={args.testScenarioNm}&status={args.status}&serviceNm={args.serviceNm}"
      ) {
      content
    }
  }
`;

export const UPDATE_TRANSACTIONID = gql`
  mutation updateTransactionId(
    $testScenarioNm: Strng
    $participantCode: Strng
    $serviceNm: Strng
    $transactionId1: Strng
    $transactionId2: Strng
  ) {
    updateTransactionId(
      testScenarioNm: $testScenarioNm
      participantCode: $participantCode
      serviceNm: $serviceNm
      transactionId1: $transactionId1
      transactionId2: $transactionId2
      input: {}
    )
      @rest(
        method: "PUT"
        type: "updateTransactionId"
        path: "api/v1/selfcertificate/assignTestScenario?serviceName={args.serviceNm}&participantCode={args.participantCode}&testScenarioName={args.testScenarioNm}&transactionId1={args.transactionId1}&transactionId2={args.transactionId2}"
      ) {
      content
    }
  }
`;

export const ADD_TEST_RULE = gql`
  mutation addTestRule($operation: String, $serviceNm: String, $testStepRulesSequences: any, $method: String) {
    addTestRule(
      input: { operation: $operation, serviceNm: $serviceNm, testStepRulesSequences: $testStepRulesSequences }
    ) @rest(method: $method, type: "addTestRule", path: "api/v1/selfcertificate/testStepRules") {
      content
    }
  }
`;
export const GET_TEST_RULES = gql`
  query {
    getTestRules @rest(method: "GET", type: "getTestRules", path: "api/v1/selfcertificate/testStepRules") {
      operation
      serviceNm
      testStepRulesSequences
      updatedOn
    }
  }
`;

export const DELETE_TEST_RULES = gql`
  mutation deleteTestRules($payload: any) {
    deleteTestRules(input: $payload)
      @rest(method: "PUT", type: "deleteTestRules", path: "api/v1/selfcertificate/testStepRules/delete") {
      operation
      serviceNm
    }
  }
`;

export const CREATE_PROFILE = gql`
  mutation createProfile($payload: any, $method: any) {
    createProfile(input: $payload)
      @rest(method: $method, type: "profileConfigData", path: "api/v1/broker/participantProfiles") {
      data
    }
  }
`;
export const DELETE_PROFILE_CONFIG = gql`
  mutation deleteProfile($payload: any) {
    deleteProfile(input: $payload)
      @rest(method: "PUT", type: "profileConfigData", path: "api/v1/broker/participantProfiles/delete") {
      data
    }
  }
`;

export const PROFILE_CONFIG_LIST = gql`
  query getProfileList($serach: String) {
    getProfileList(search: $search)
      @rest(method: $method, type: "profileConfigData", path: "api/v1/broker/participantProfiles{args.search}") {
      content
      pageable
      totalElements
    }
  }
`;

export const GET_CONFIGURATION_SETTINGS = gql`
  query configurationSettings($applicationId: String, $keys: any) {
    configurationSettings(input: { applicationId: $applicationId, keys: $keys })
      @rest(
        method: "POST"
        type: "configurationSettings"
        path: "lui/uiConfiguration/v1/all/configurations?"
        endpoint: "v2"
      ) {
      data
    }
  }
`;

export const USER_CONFIGURATION_SETTINGS = gql`
  mutation userConfigurationSettings($applicationId: String, $key: any, $hierarchy: any, $configuration: any) {
    userConfigurationSettings(
      input: { applicationId: $applicationId, key: $key, hierarchy: $hierarchy, configuration: $configuration }
    )
      @rest(
        method: "POST"
        type: "userConfigurationSettings"
        path: "lui/uiConfiguration/v1/configuration?"
        endpoint: "v2"
      ) {
      data
    }
  }
`;

export default ERROR_DIAGNOSIS_QUERY;
